import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useConfirm } from "../../../hooks/useConfirm";
import { ModalFormConvenia } from "./components/ModalConvenia";
import { IConfiguration } from "../../../@types/configuration.type";
import {
  addOrUpdateConfigurations,
  searchConfigurationsByKeys,
} from "../../../services/api/Configurations/ConfigurationService";
import { IApiResponse } from "../../../@types/api-response.type";
import { ModalFormJira } from "./components/ModalJira";
import vectorIcon from "../../../assets/_VectorIcon_.svg";
import { useNavigate } from "react-router-dom";
import { CardConvenia } from "./components/CardConvenia";
import { CardJira } from "./components/CardJira";
import { CardLG } from "./components/CardLG";
import { ModalFormLG } from "./components/ModalLG";
import { Button } from "../../../ui";
import { toast } from "react-toastify";

export function Synchronization() {
  const [isConveniaConfigured, setIsConveniaConfigured] =
    useState<boolean>(false);
  const [configurations, setConfigurations] = useState<IConfiguration[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [openJira, setOpenJira] = useState(false);
  const [openLG, setOpenLG] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [jiraConfigurations, setJiraConfigurations] = useState<IConfiguration[]>([]);
  const [isJiraConfigured, setIsJiraConfigured] = useState<boolean>(false);
  const handleOpenJira = () => setOpenJira(true);
  const handleCloseJira = () => setOpenJira(false);

  const [lgConfigurations, setLGConfigurations] = useState<IConfiguration[]>([]);
  const [isLGConfigured, setIsLGConfigured] = useState<boolean>(false);
  const handleOpenLG = () => setOpenLG(true);
  const handleCloseLG = () => setOpenLG(false);

  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  // const handleOpenModalConfirm = () => setOpenModalConfirm(true);
  const handleCloseModalConfirm = () => setOpenModalConfirm(false);
  const { showConfirm, Confirm } = useConfirm(
    "Deseja realmente desconectar?",
    openModalConfirm,
    handleCloseModalConfirm,
    "Você não poderá mais sinconizer seus dados com esse serviço externo."
  );

  const navigate = useNavigate();
  const configurationKeys: string[] = [
    "CONFIGURATION_CONVENIA_TOKEN",
    "CONFIGURATION_JIRA_EMAIL",
    "CONFIGURATION_JIRA_API_TOKEN",
    "CONFIGURATION_JIRA_URL",
    "CONFIGURATION_LG_USER",
    "CONFIGURATION_LG_PASSWORD",
    "CONFIGURATION_LG_GUIDTENANT",
    "CONFIGURATION_LG_URL",
    "CONFIGURATION_LG_ENVIRONMENT",
  ];

  useEffect(() => {
    setLoading(true);
    searchConfigurationsByKeys(configurationKeys).then((response) => {
      let availableConfigurations = (response as IApiResponse<IConfiguration[]>).result;

      setConfigurations(
        availableConfigurations.filter(
          (x) => x.key === "CONFIGURATION_CONVENIA_TOKEN"
        )
      );
      setIsConveniaConfigured(
        availableConfigurations.some(
          (x) => x.key === "CONFIGURATION_CONVENIA_TOKEN" && x.value !== ""
        )
      );

      setJiraConfigurations(
        availableConfigurations.filter(
          (x) =>
            x.key === "CONFIGURATION_JIRA_API_TOKEN" ||
            x.key === "CONFIGURATION_JIRA_EMAIL" ||
            x.key === "CONFIGURATION_JIRA_URL"
        )
      );
      setIsJiraConfigured(
        availableConfigurations.some(
          (x) =>
            (x.key === "CONFIGURATION_JIRA_API_TOKEN" ||
              x.key === "CONFIGURATION_JIRA_EMAIL" ||
              x.key === "CONFIGURATION_JIRA_URL") &&
            x.value !== ""
        )
      );
      
      setLGConfigurations(
        availableConfigurations.filter(
          (x) =>
            x.key === "CONFIGURATION_LG_USER" ||
            x.key === "CONFIGURATION_LG_PASSWORD" ||
            x.key === "CONFIGURATION_LG_URL" ||
            x.key === "CONFIGURATION_LG_ENVIRONMENT" ||
            x.key === "CONFIGURATION_LG_GUIDTENANT"
        )
      );
      setIsLGConfigured(
        availableConfigurations.some(
          (x) =>
            (
              x.key === "CONFIGURATION_LG_USER" ||
              x.key === "CONFIGURATION_LG_PASSWORD" ||
              x.key === "CONFIGURATION_LG_URL" ||
              x.key === "CONFIGURATION_LG_ENVIRONMENT" ||
              x.key === "CONFIGURATION_LG_GUIDTENANT"
            ) &&
            x.value !== ""
        )
      );
    });
    setLoading(false);
  }, []);

  const saveConveniaConfiguration = async (token: string) => {
    setLoading(true);
    try {
      let configurationsToUpdate = configurations.filter(
        (x) => x.key === "CONFIGURATION_CONVENIA_TOKEN"
      );
      for (let index = 0; index < configurationsToUpdate.length; index++) {
        configurationsToUpdate[index].value = token;
      }
      addOrUpdateConfigurations(configurationsToUpdate).then(() => {
        setIsConveniaConfigured(token !== "");
        setConfigurations(configurationsToUpdate);
      });
    } catch (error) {
      console.log(error);
      toast.error("Error");
    } finally{
      setLoading(false);
    }
  };

  const saveJiraConfiguration = async (
    token: string,
    email: string,
    url: string
  ) => {
    setLoading(true);

    try {
      const jiraConfigurationToken = {
        key: "CONFIGURATION_JIRA_API_TOKEN",
        value: token,
      };
      const jiraConfigurationEmail = {
        key: "CONFIGURATION_JIRA_EMAIL",
        value: email,
      };
      const jiraConfigurationUrl = { key: "CONFIGURATION_JIRA_URL", value: url };
      const newJiraConfigurations = [
        jiraConfigurationToken,
        jiraConfigurationEmail,
        jiraConfigurationUrl,
      ];

      addOrUpdateConfigurations(newJiraConfigurations).then(() => {
        setIsJiraConfigured(token !== "");
        setJiraConfigurations(newJiraConfigurations);
      });
    } catch (error) {
      console.log(error);
      toast.error("Error");
    } finally{
      setLoading(false);
    }
  };

  const saveLGConfiguration = async (
    token: string,
    user: string, 
    password: string,
    url: string,
    environment: string,
  ) => {
    setLoading(true);

    try {
      const lgConfigurationToken = {
        key: "CONFIGURATION_LG_GUIDTENANT",
        value: token,
      };
      const lgConfigurationUser = {
        key: "CONFIGURATION_LG_USER",
        value: user,
      };
      const lgConfigurationPassword = {
        key: "CONFIGURATION_LG_PASSWORD",
        value: password,
      };
      const lgConfigurationUrl = {
        key: "CONFIGURATION_LG_URL",
        value: url,
      };
      const lgConfigurationEnvironment = {
        key: "CONFIGURATION_LG_ENVIRONMENT",
        value: environment,
      };

      const newLGConfigurations = [
        lgConfigurationToken,
        lgConfigurationUser,
        lgConfigurationPassword,
        lgConfigurationUrl,
        lgConfigurationEnvironment
      ];

      addOrUpdateConfigurations(newLGConfigurations).then(() => {
        setIsLGConfigured(token !== "");
        setLGConfigurations(newLGConfigurations);
      });
    } catch (error) {
      console.log(error);
      toast.error("Error");
    } finally{
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.configurationsStyle}>
        <div className={styles.back}>
          <Button
            className={styles.buttonMui}
            onClick={() => navigate("/configurations")}
          >
            {vectorIcon && <img src={vectorIcon} />}
            Voltar a tela anterior
          </Button>
        </div>
        <div className={styles.titleAndBtnCreate}>
          <h1>Sincronização de Dados</h1>
        </div>
        {loading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress size={100} />
          </div>
        ) : (
          <div className={styles.externalSources}>
            <CardConvenia
              isConveniaConfigured={isConveniaConfigured}
              configurations={configurations}
              setLoading={setLoading}
              handleOpen={handleOpen}
              showConfirm={showConfirm}
              setIsConveniaConfigured={setIsConveniaConfigured}
            />

            <CardJira
              isJiraConfigured={isJiraConfigured}
              configurations={jiraConfigurations}
              setLoading={setLoading}
              handleOpen={handleOpenJira}
              showConfirm={showConfirm}
              setIsJiraConfigured={setIsJiraConfigured}
            />

            <CardLG
              isLGConfigured={isLGConfigured}
              configurations={lgConfigurations}
              setLoading={setLoading}
              handleOpen={handleOpenLG}
              showConfirm={showConfirm}
              setIsLGConfigured={setIsLGConfigured}
            />
          </div>
        )}
        {Confirm}
      </div>
      <ModalFormConvenia
        configurations={configurations}
        open={open}
        handleClose={handleClose}
        handleSave={function (token: string): void {
          handleClose();
          saveConveniaConfiguration(token);
        }}
      />

      <ModalFormJira
        configurations={jiraConfigurations}
        open={openJira}
        handleClose={handleCloseJira}
        handleSave={function (token: string, email: string, url: string): void {
          handleCloseJira();
          saveJiraConfiguration(token, email, url);
        }}
      />

      <ModalFormLG
        configurations={lgConfigurations}
        open={openLG}
        handleClose={handleCloseLG}
        handleSave={function (token: string, user: string, password: string, url: string, environment: string): void {
          handleCloseLG();
          saveLGConfiguration(token, user, password, url, environment);
        }}
      />
    </>
  );
};
